import { c as _c } from "react/compiler-runtime";
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { LinkButton, LoadingSpinner, Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { VaultType } from '@/entities/hooks/use-entity-vault';
import useDecryptOnboarding from './use-decrypt-onboarding';
type DecryptProps = {
  entity: Entity;
  canDecrypt: boolean;
  onboarding: EntityOnboarding;
  onDecryptSuccess: (vault: VaultType) => void;
  vaultData: VaultType | undefined;
};
const Decrypt = t0 => {
  const $ = _c(21);
  const {
    canDecrypt,
    onDecryptSuccess,
    onboarding,
    vaultData,
    entity
  } = t0;
  const {
    t
  } = useTranslation("entity-details");
  let t1;
  if ($[0] !== entity || $[1] !== onDecryptSuccess || $[2] !== onboarding || $[3] !== vaultData) {
    t1 = {
      entity,
      onboarding,
      onDecryptSuccess,
      vaultData
    };
    $[0] = entity;
    $[1] = onDecryptSuccess;
    $[2] = onboarding;
    $[3] = vaultData;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    decrypt,
    isDecrypting
  } = useDecryptOnboarding(t1);
  let t2;
  if ($[5] !== vaultData?.vault) {
    t2 = Object.keys(vaultData?.vault || {});
    $[5] = vaultData?.vault;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const isVaultEmpty = t2.length === 0;
  if (isDecrypting) {
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <LoadingSpinner size="compact" />;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  let t3;
  if ($[8] !== isVaultEmpty || $[9] !== t) {
    t3 = isVaultEmpty ? t(_temp) : t(_temp2);
    $[8] = isVaultEmpty;
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = !canDecrypt;
  let t5;
  if ($[11] !== t) {
    t5 = t(_temp3);
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== decrypt || $[14] !== t4 || $[15] !== t5) {
    t6 = <LinkButton disabled={t4} onClick={decrypt}>{t5}</LinkButton>;
    $[13] = decrypt;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== canDecrypt || $[18] !== t3 || $[19] !== t6) {
    t7 = <Tooltip disabled={canDecrypt} content={t3}>{t6}</Tooltip>;
    $[17] = canDecrypt;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default Decrypt;
function _temp($) {
  return $.decrypt.vaultEmptyNotAllowed;
}
function _temp2($_0) {
  return $_0.decrypt.notAllowed;
}
function _temp3($_1) {
  return $_1.onboardings.userData.decrypt.decryptAll;
}